export class WhitelistedUsersResponseModel extends Array<WhitelistedUserResponseModel> {}
export class WhitelistedUserResponseModel {
    constructor(public customerUuid: string) {}
}
